import { IConfig } from '../interfaces/patternsConfig.interface';

export const config: IConfig = {
  general: {
    minimumH2: 2,
    tagsToIgnore: ['UL', 'OL', 'QUOTE'],
    makeTagsUnique: ['H2'],
  },
  patterns: {
    'listing-article': {
      name: 'Listing Article',
      groups: [
        {
          name: 'Introduction',
          delimiters: [
            {
              delimiter: 'start',
            },
            {
              delimiter: 'H2',
              first: true,
            },
          ],
          blocks: [
            {
              tag: 'PARAGRAPH',
              amount: [1, 2],
            },
            // {
            //   tag: ['IMAGE', 'VIDEO'],
            //   amount: 1,
            // },
          ],
        },
        {
          name: 'Subheading',
          delimiters: [
            {
              delimiter: 'H2',
              first: true,
            },
            {
              delimiter: 'H2',
              last: true,
            },
          ],
          separator: 'H2',
          blocks: [
            // {
            //   tag: 'PARAGRAPH',
            //   amount: 1,
            // },
            // {
            //   tag: ['IMAGE', 'VIDEO'],
            //   amount: 1,
            // },
            {
              tag: 'PARAGRAPH',
              amount: [1, 4],
            },
            {
              optional: true,
              repeats: true,
              blocks: [
                {
                  tag: 'H3',
                  amount: 1,
                },
                {
                  tag: 'PARAGRAPH',
                  amount: [1, 3],
                },
              ],
            },
          ],
        },
        {
          name: 'Conclusion',
          delimiters: [
            {
              delimiter: 'H2',
              last: true,
            },
            {
              delimiter: 'end',
            },
          ],
          blocks: [
            {
              tag: 'PARAGRAPH',
              amount: [1, 4],
            },
          ],
        },
      ],
    },
    'educational-article': {
      name: 'Educational Article',
      groups: [
        {
          name: 'Introduction',
          delimiters: [
            {
              delimiter: 'start',
            },
            {
              delimiter: 'H2',
              first: true,
            },
          ],
          blocks: [
            {
              tag: 'PARAGRAPH',
              amount: [1, 3],
            },
            // {
            //   tag: ['IMAGE', 'VIDEO'],
            //   amount: 1,
            // },
          ],
        },
        {
          name: 'Subheading',
          delimiters: [
            {
              delimiter: 'H2',
              first: true,
            },
            {
              delimiter: 'H2',
              last: true,
            },
          ],
          separator: 'H2',
          blocks: [
            // {
            //   tag: 'PARAGRAPH',
            //   amount: 1,
            // },
            // {
            //   tag: ['IMAGE', 'VIDEO'],
            //   amount: 1,
            // },
            {
              tag: 'PARAGRAPH',
              amount: [1, 4],
            },
            {
              optional: true,
              repeats: true,
              blocks: [
                {
                  tag: 'H3',
                  amount: 1,
                },
                {
                  tag: 'PARAGRAPH',
                  amount: [1, 3],
                },
              ],
            },
          ],
        },
        {
          name: 'Conclusion',
          delimiters: [
            {
              delimiter: 'H2',
              last: true,
            },
            {
              delimiter: 'end',
            },
          ],
          blocks: [
            {
              tag: 'PARAGRAPH',
              amount: [1, 4],
            },
          ],
        },
      ],
    },
    'presell-article': {
      name: 'Presell Article',
      groups: [
        {
          name: 'Introduction',
          delimiters: [
            {
              delimiter: 'start',
            },
            {
              delimiter: 'H2',
              first: true,
            },
          ],
          blocks: [
            {
              tag: 'PARAGRAPH',
              amount: [1, 5],
            },
            // {
            //   tag: ['IMAGE', 'VIDEO'],
            //   amount: 1,
            // },
          ],
        },
        {
          name: 'Subheading',
          delimiters: [
            {
              delimiter: 'H2',
              first: true,
            },
            {
              delimiter: 'H2',
              last: true,
            },
          ],
          separator: 'H2',
          blocks: [
            // {
            //   tag: 'PARAGRAPH',
            //   amount: 1,
            // },
            // {
            //   tag: ['IMAGE', 'VIDEO'],
            //   amount: 1,
            // },
            {
              tag: 'PARAGRAPH',
              amount: [1, 4],
            },
            {
              optional: true,
              repeats: true,
              blocks: [
                {
                  tag: 'H3',
                  amount: 1,
                },
                {
                  tag: 'PARAGRAPH',
                  amount: [1, 3],
                },
              ],
            },
          ],
        },
        {
          name: 'Conclusion',
          delimiters: [
            {
              delimiter: 'H2',
              last: true,
            },
            {
              delimiter: 'end',
            },
          ],
          blocks: [
            {
              tag: 'PARAGRAPH',
              amount: [1, 4],
            },
          ],
        },
      ],
    },
  },
};
